// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__AyobF","container_body":"Modal_container_body__hmKq-","modal":"Modal_modal__2HddE","modal_body":"Modal_modal_body__6yWTx"};